import axios from 'axios'
import _ from 'lodash'
import store from '@/store'
import { toLogout } from '@/router'
import { ElMessage } from 'element-plus'
// import { refresh } from '@/api/admin/auth'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['Cache-Control'] = 'no-cache'
axios.defaults.headers['Pragma'] = 'no-cache'

// 统一的响应错误处理器（两个实例共用）
async function responseErrorHandler(error) {
  const res = { success: false, code: 0, msg: '' }

  if (error?.response) {
    if (error.config._request) {
      return res
    }

    const { config, data, status } = error.response
    if (_.isNumber(status)) {
      res.code = status
    }
    if (_.isPlainObject(data)) {
      _.merge(res, data)
    } else if (_.isString(data)) {
      res.msg = data || error.response.statusText
    }

    // 刷新令牌
    const { code } = res
    if (code === 401) {
      toLogout()
      // const resRefresh = await refresh({ token: store.getters.token })
      // if (resRefresh.code === "1") {
      //   store.commit('user/setToken', resRefresh.data.token)
      //   error.config._request = true
      //   return requestAxios.request(error.config)
      // } else {
      //   toLogout()
      //   return res
      // }
    }

    // 错误消息
    if (!config.api?.noErrorMsg && res.msg) {
      const duration = config.api?.msgDuration >= 0 ? config.api?.msgDuration : 3000
      ElMessage.error({
        message: res.msg,
        duration: duration
      })
    }
  }
  return res
}

// 创建请求实例并挂载通用拦截器
function createRequest(baseURL) {
  const instance = axios.create({
    baseURL,
    timeout: 20000 // 请求延时
  })

  // 拦截请求
  instance.interceptors.request.use(
    config => {
      if (config.api?.auth === false) {
        return config
      }
      const token = store.getters.token
      if (token) {
        // config.headers.Authorization = 'Bearer ' + token
        config.headers.token = token
      }

      return config
    },
    err => {
      return Promise.reject(err)
    }
  )

  // 拦截响应
  instance.interceptors.response.use(
    response => {
      const { config, data } = response
      // 兼容两套后端的成功码：老小柔返回 code="200" / 200；rouling-cloud 返回 code=0 / "0"
      const isSuccess = data.code === '200' || data.code === 200 || data.code === 0 || data.code === '0'
      data.success = isSuccess
      if (!data.success && !config.api?.noErrorMsg && data.msg) {
        const duration = config.api?.msgDuration >= 0 ? config.api?.msgDuration : 3000
        ElMessage.error({
          message: data.msg,
          duration: duration
        })
      }
      if (data.code === '1000' && data.msg === '登录失效') {
        toLogout()
      }
      return data
    },
    responseErrorHandler
  )

  return instance
}

// 老小柔后端（现有所有接口默认走这里，import request / import default）
const request = createRequest(process.env.VUE_APP_BASE_API)
// rouling-cloud 运营后端（新 ops 接口走这里，import { requestOps }）
const requestOps = createRequest(process.env.VUE_APP_BASE_API_OPS)

export { request, requestOps }
export default request
